import React, { useEffect, useState } from "react";

const useFirstImagePreloader = (imageUrls: string[]): boolean => {
    const [isLoaded, setIsLoaded] = useState(false);

    useEffect(() => {
        if (imageUrls?.length > 0) {
            const img = new Image();
            img.src = imageUrls[0]; // Only preload the first image
            img.onload = () => setIsLoaded(true);
            img.onerror = () => setIsLoaded(true); // Handle error gracefully
        } else {
            setIsLoaded(true); // No images to preload
        }
    }, [imageUrls]);

    return isLoaded; // Returns the preload status of the first image
};

export default useFirstImagePreloader;
